import { Subject, Subscription } from "rxjs";
import { ApiResultEvent } from "./types";

const apiResultSubject = new Subject<ApiResultEvent>();

export const emitApiResult = (event: ApiResultEvent) => {
  apiResultSubject.next(event);
};

export const subscribeToApiResults = (
  listener: (event: ApiResultEvent) => void
): (() => void) => {
  const subscription: Subscription = apiResultSubject.subscribe(listener);

  return () => {
    subscription.unsubscribe();
  };
};
